<table class="table-striped table-hover custom-table" *ngIf="options?.records.length > 0">
  <thead>
    <tr>
      <th *ngFor="let column of options?.columns">
        <span [innerHTML]="column.name"></span>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let row of options?.records; let rowIndex = index" [ngStyle]="row.style">
      <td *ngFor="let column of options?.columns; let columnIndex = index" [ngStyle]="column.style">
        <ng-container *ngIf="!column.isIcon && !column.isCellClick">
          <span [innerHTML]="column['cellValue' + rowIndex + columnIndex]"></span>
        </ng-container>
        <ng-container *ngIf="column.isCellClick">
          <a href="javascript:void(0)" (click)="cellClick(row, column)" style="display: flex; gap: 5px">
            <span [innerHTML]="column['cellValue' + rowIndex + columnIndex]"></span>
            <finra-icon
              *ngIf="column.iconName && column['cellValue' + rowIndex + columnIndex]"
              family="regular"
              tabindex="0"
              role="button"
              [icon]="column.iconName"
              [attr.aria-label]="column['cellValue' + rowIndex + columnIndex]"
              [attr.title]="row['col' + columnIndex]?.title ?? column.title"
              size="xs"
              [style.fill]="column | iconColor"
            ></finra-icon>
          </a>
        </ng-container>
        <ng-container *ngIf="column.isIcon && !column.isCellClick && column['cellValue' + rowIndex + columnIndex]">
          <finra-icon
            family="regular"
            tabindex="0"
            role="button"
            [icon]="column.iconName || column['cellValue' + rowIndex + columnIndex]"
            (keyup.enter)="iconClick(row, column)"
            (keyup.space)="iconClick(row, column)"
            [attr.aria-label]="column['cellValue' + rowIndex + columnIndex]"
            [attr.title]="row['col' + columnIndex]?.title ?? column.title"
            (click)="iconClick(row, column)"
            size="xs"
            [style.fill]="column | iconColor"
          ></finra-icon>
        </ng-container>
      </td>
    </tr>
  </tbody>
</table>
